import { ServiceApi } from './service-api';
import { ConfigService } from '../../Core/Config/services/config.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class NeptuneApi extends ServiceApi {
    constructor(
        public httpClient: HttpClient,
        public cookieService: CookieService,
        public configurationService: ConfigService
    ) {
        super(httpClient, cookieService, configurationService);

        this.apiUrl = configurationService.getConfig().apiUrl;
    }
}
